const CHANNEL_NAMES: { [key: string]: any } = {
  AirDensity_dG31: {
    displayName: 'Air Density',
    description: '',
  },
  AirPitch_AG11: {
    displayName: 'Pitch Angle',
    description: 'StratusC only: nose down positive, from the probe pitch hole',
  },
  AirYaw_AG11: {
    displayName: 'Yaw Angle Raw',
    description: 'Without Cp Correction',
  },
  AirYaw_AG21: {
    displayName: 'Yaw Angle',
    description: '',
  },
  AirYaw_AG31: {
    displayName: 'Yaw Angle Calibrated',
    description: 'Calibrated for Bicycle',
  },
  AirYaw_AG31_Absolute: {
    displayName: 'Yaw Angle Calibrated',
    description: 'Calibrated for Bicycle',
    calculation: (data: any) => {
      return data['AirYaw_AG31']?.map((value: number) => Math.abs(value));
    },
  },
  Baro_pG31: {
    displayName: 'Barometric Pressure',
    description: '',
  },
  Baro_pG21: {
    displayName: 'Barometric Pressure Raw',
    description: 'Without Cp Correction',
  },
  BodyPosChest_sG21: {
    displayName: 'Body - Chest',
    description: 'Distance from Reference',
    unit: 'm',
  },
  BodyPosRefChest_sG11: {
    displayName: 'Body - Chest Reference',
    description: 'Distance from Sensor to Chest in Reference Position',
    unit: 'm',
  },
  BodyPosChest_sG21_cm: {
    displayName: 'Body - Chest',
    description: 'Distance from Reference',
    unit: 'cm',
    calculation: (data: any) => {
      return data['BodyPosChest_sG21']?.map((value: number) => value * 100);
    },
  },
  BodyPosRefChest_sG11_cm: {
    displayName: 'Body - Chest Reference',
    description: 'Distance from Sensor to Chest in Reference Position',
    unit: 'cm',
    calculation: (data: any) => {
      return data['BodyPosRefChest_sG11']?.map((value: number) => value * 100);
    },
  },
  BodyPosChestDelta_sG21_cm: {
    displayName: 'Body - Chest',
    description: 'Distance from Reference to Chest',
    unit: 'cm',
    calculation: (data: any) => {
      return data['BodyPosChest_sG21']?.map((value: number, index: number) => {
        return (value - data['BodyPosRefChest_sG11'][index]) * 100;
      });
    },
  },
  BodyPosHead_sG21: {
    displayName: 'Body - Head',
    description: 'Distance from Reference',
    unit: 'm',
  },
  BodyPosRefHead_sG11: {
    displayName: 'Body - Head Reference',
    description: 'Distance from Sensor to Chest in Reference Position',
    unit: 'cm', // Not sure why this is in cm
  },
  BodyPosHead_sG21_cm: {
    displayName: 'Body - Head',
    description: 'Distance from Reference',
    unit: 'cm',
    calculation: (data: any) => {
      return data['BodyPosHead_sG21']?.map((value: number) => value * 100);
    },
  },
  BodyPosRefHead_sG11_cm: {
    displayName: 'Body - Head Reference',
    description: 'Distance from Sensor to Chest in Reference Position',
    unit: 'cm',
    calculation: (data: any) => {
      return data['BodyPosRefHead_sG11']?.map((value: number) => value * 100);
    },
  },
  BodyPosHeadDelta_sG21_cm: {
    displayName: 'Body - Head',
    description: 'Distance from Reference to Head',
    unit: 'cm',
    calculation: (data: any) => {
      return data['BodyPosHead_sG21']?.map((value: number, index: number) => {
        return (value - data['BodyPosRefHead_sG11'][index]) * 100;
      });
    },
  },
  BodyPosWaist_sG21: {
    displayName: 'Body - Waist',
    description: 'Distance from Reference',
    unit: 'm',
  },
  BodyPosRefWaist_sG11: {
    displayName: 'Body - Waist Reference',
    description: 'Distance from Sensor to Chest in Reference Position',
    unit: 'cm', // Not sure why this is in cm
  },
  BodyPosWaist_sG21_cm: {
    displayName: 'Body - Waist',
    description: 'Distance from Reference',
    unit: 'cm',
    calculation: (data: any) => {
      return data['BodyPosWaist_sG21']?.map((value: number) => value * 100);
    },
  },
  BodyPosRefWaist_sG11_cm: {
    displayName: 'Body - Waist Reference',
    description: 'Distance from Sensor to Chest in Reference Position',
    unit: 'cm',
    calculation: (data: any) => {
      return data['BodyPosRefWaist_sG11']?.map((value: number) => value * 100);
    },
  },
  BodyPosWaistDelta_sG21_cm: {
    displayName: 'Body - Waist',
    description: 'Distance from Reference to Waist',
    unit: 'cm',
    calculation: (data: any) => {
      return data['BodyPosWaist_sG21']?.map((value: number, index: number) => {
        return (value - data['BodyPosRefWaist_sG11'][index]) * 100;
      });
    },
  },
  Distance_km: {
    displayName: 'Distance',
    description: 'Distance of Traverse',
    unit: 'km',
    calculation: (data: any, calibration: any) => {
      const wheelCircumference = getWheelCircumference(calibration); // meters
      return data['WhlRrev_N']?.map((wheelRevolutions: number) => (wheelRevolutions * wheelCircumference) / 1000); // km
    },
  },
  DynPres_pG21: {
    displayName: 'Dynamic Pressure Raw',
    description: 'Without Cp Correction',
  },
  GpsAltitude_sG10: {
    displayName: 'Altitude - GPS',
    description: '',
  },
  GpsRoutePos_sG20: {
    displayName: 'Route Position',
    description: 'Distance along reference route',
    unit: 'm',
  },
  GpsBearing_AG10: {
    displayName: 'Bearing',
    description: '',
  },
  GpsLat_AG10: {
    displayName: 'Latitude',
    description: '',
  },
  GpsLon_AG10: {
    displayName: 'Longitude',
    description: '',
  },
  CrankCad_R: {
    displayName: 'Cadence',
    description: 'Crank cadence as stored — rev/s, not rpm',
  },
  CrankAltCad_R: {
    displayName: 'Cadence 2',
    description: 'Secondary cadence source as stored — rev/s, not rpm',
  },
  RiderPwr_P: {
    displayName: 'Power',
    description: '',
  },
  Temp_TG11: {
    displayName: 'Air Temperature',
    description: '',
  },
  TimeAbs_tG00: {
    displayName: 'Time (Day)',
    description: '',
  },
  TraverseLap_NG00: {
    displayName: 'Traverse Lap',
    description: 'Integer traverse counter',
  },
  TraverseLap_NG10: {
    displayName: 'Traverse Lap (Windowed)',
    description: 'Traverse counter windowed to ±15s around gates and between gates',
  },
  TimeRel_tG00: {
    displayName: 'Time (Seconds)',
    description: '',
  },
  WhlRrev_N: {
    displayName: 'Wheel Revolutions',
    description: '',
  },
  WhlRspd_n: {
    displayName: 'Wheel Speed',
    description: '',
  },
  WhlRacc_h: {
    displayName: 'Wheel Accleration',
    description: '',
  },
  WhlLspd_v: {
    displayName: 'Speed',
    description: '',
  },
  WindAbs_vG31: {
    displayName: 'Wind Speed',
    description: '',
  },
  AirVelocity: {
    displayName: 'Air Speed',
    description: '',
  },
  Aero: {
    displayName: 'Power - Aerodynamics',
    description: 'Watts required only to overcome aerodynamic force',
  },
  Alpha: {
    displayName: 'Power - Alpha',
    description: 'Watts required overcome aerodynamic force if CdA = 1',
  },
  'CdA Normalised Full': {
    displayName: 'CdA',
    description: 'Normalised CdA',
  },
  'CdA Normalised w/o Body': {
    displayName: 'CdA w/o Body',
    description: 'Normalised CdA without Body Position',
  },
  'CdA Raw': {
    displayName: 'CdA Raw',
    description: 'CdA without crosswind angle normalisation',
  },
  Chest: {
    displayName: 'Body - Chest',
    description: 'Distance from Reference',
  },
  'Chest Deviation': {
    displayName: 'Body - Chest Variance',
    description: 'Standard deviation of the Chest Postion',
  },
  CpCorr: {
    displayName: 'Cp Correction - Calibration',
    description: 'Calibration for slowing of air around bicycle',
  },
  'CpCorr Calc': {
    displayName: 'Cp Correction  - Calculated',
    description: 'Calculated value for Cp Correction',
  },
  Crr: {
    displayName: 'Crr - Calibration',
    description: 'Calibration for Rolling Resistance',
  },
  'Crr Calc': {
    displayName: 'Crr - Calculated',
    description: 'Crr value calculated using a Reference CdA value',
  },
  Distance: {
    displayName: 'Distance',
    description: 'Distance of Traverse',
  },
  Duration: {
    displayName: 'Duration',
    description: 'Duration of Traverse',
  },
  'Elevation Difference': {
    displayName: 'Elevation Difference',
    description: 'Elevation distance across traverse',
  },
  Grav: {
    displayName: 'Power - Gravitational',
    description:
      'Watts required to overcome gravitational force. ' +
      'Will be negative traverse is downhill.Increases with speed.',
  },

  '  Head': {
    displayName: 'Body - Head',
    description: 'Distance from Reference',
  },
  'Head Deviation': {
    displayName: 'Body - Head Variance',
    description: 'Standard deviation of the Head Postion',
  },
  'Headwind m/s': {
    displayName: 'Headwind m/s',
    description: 'The wind speed in the opposite direction of the rider',
  },
  Kinetic: {
    displayName: 'Power - Kinetic',
    description:
      'Power required to accelerate the bicycle during the traverse. ' +
      'May be negative, indicates that the bike decelerates.',
  },
  'Mass Combined': {
    displayName: 'Mass Combined',
    description: '',
  },
  Power: {
    displayName: 'Power',
    description: 'Rider Power',
  },
  'Power IsoAirSpd': {
    displayName: 'Power - Constant Air Speed',
    description: 'Rider Power for constant airspeed across both traverses',
  },
  'Power Meter Slope': {
    displayName: 'Power Meter Slope - Calibration',
    description: 'Calibration value to account for variance in power meter, as well as drivetrain losses',
  },
  AirSpeed: {
    displayName: 'Air Speed',
    description: 'Air speed of the rider and bicycle.',
    unit: 'km/hr',
    calculation: (data: any, calibration: any) => {
      const dynamicPressures = data['DynPres_pG21']; // Pa = kg/m/s^2
      const airDensities = data['AirDensity_dG31']; // kg/m^3
      return dynamicPressures?.map((dynamicPressure: number, index: number) => {
        const airDensity = airDensities[index];
        // Filter negative dynamic pressures to zero
        const filteredPressure = Math.max(0, dynamicPressure);
        // sqrt( (kg/m/s^2) / kg/m^3) = sqrt(m^2/s^2) = m/s
        const airSpeed = Math.sqrt((2 * filteredPressure * calibration.cp_corr) / airDensity); // m/s
        return (airSpeed * 3600) / 1000; // km/hr
      });
    },
  },
  RoadSpeed: {
    displayName: 'Road Speed',
    description: 'Road speed of the rider and bicycle.',
    unit: 'km/hr',
    calculation: (data: any, calibration: any) => {
      const wheelSpeeds = data['WhlRspd_n']; // revolutions per second
      const wheelCircumference = getWheelCircumference(calibration); // meters
      return wheelSpeeds?.map((wheelSpeed: number) => (wheelSpeed * wheelCircumference * 3600) / 1000); // km/hr
    },
  },
  // The speed source the run did NOT use, for comparison: the wheel sensor
  // on a GPS-speed run, GPS on a wheel-sensor run. Both are stored in m/s.
  // `calibration.gps_speed` must say what the run actually used — see
  // RunPlotter, which sets it from the run's speed selection.
  AlternateSpeed: {
    displayName: 'Alternate Speed',
    description: 'Road speed from the source the run was not processed with.',
    unit: 'km/hr',
    calculation: (data: any, calibration: any) => {
      const alternate = calibration?.gps_speed
        ? data['WhlSensorLspd_v']
        : (data['GpsSpeed_vG20'] ?? data['GpsSpeed_vG10']);
      return alternate?.map((speed: number) => speed * 3.6); // km/hr
    },
  },
  Rolling: {
    displayName: 'Power - Rolling',
    description: 'Power required to roll tires over the road at speed.',
  },
  'Run Number': {
    displayName: 'Run Number',
    description: 'The designated run number within the Session',
  },
  Speed: {
    displayName: 'Speed',
    description: 'Ground speed of the rider and bicycle.',
  },
  'Start Time': {
    displayName: 'Start Time',
    description: 'Start time of run in local time zone',
  },
  'Start Time UTC': {
    displayName: 'Start Time UTC',
    description: 'Start time of run in Universal Coordinated Time',
  },
  Traverses: {
    displayName: 'Traverses',
    description: 'Number of traverses in run',
  },
  'Wheel Circ Calc': {
    displayName: 'Wheel Circumference - Calculated',
    description: 'Calculated value for the circumference of the wheel. Uses wheel revolutions and GPS.',
  },
  'Wheel Circumference': {
    displayName: 'Wheel Circumference - Calibration',
    description: 'Calibration value for the circumference of the wheel',
  },
  'Wind Dir °': {
    displayName: 'Wind Dir °',
    description: 'The direction of the wind for an observer on the ground, relative to absolute north.',
  },
  'Wind Speed m/s': {
    displayName: 'Wind Speed m/s',
    description: 'The speed of the wind over ground',
  },
  Yaw: {
    displayName: 'Yaw',
    description:
      'The cross wind angle that the rider experiences across the traverse. ' +
      'Negative and positive values will average to zero.',
  },
  'Yaw (abs)': {
    displayName: 'Yaw (abs)',
    description:
      'The cross wind angle that the rider experiences across the traverse. ' +
      'The magnitude of negative and positive values will be averaged.',
  },
  'Yaw Offset': {
    displayName: 'Yaw Offset - Calibration',
    description: 'The misalignment of the sensor as a calibration value',
  },
  'Yaw Offset Calc': {
    displayName: 'Yaw Offset - Calculated',
    description: 'The measure misalignment of the sensor',
  },
  Zeta: {
    displayName: 'Power - Zeta',
    description: 'E83',
  },
};

export const getChannel = (data: any, name: string, calibration: any): any => {
  if (!data) {
    return null;
  }
  try {
    const channelName = CHANNEL_NAMES[name];
    if (!channelName) {
      throw new Error(`Invalid channel name: ${name}`);
    }

    if (channelName.calculation) {
      return channelName.calculation(data, calibration);
    }

    return data[name];
  } catch (error) {
    console.error(`Error getting channel ${name}:`, error);
    return null;
  }
};

export const getWheelCircumference = (calibration: any) => {
  if (calibration?.gps_speed) {
    return 1.0;
  }
  return calibration?.wheel_circumference || 2.1;
};
